import { gql } from "@apollo/client";

export default gql`
  fragment StripeInvoiceFields on Invoice {
    id
    friendlyId
    status
    paidAt
    amount
    currency
    amountRefunded
    receiptUrl
    card {
      brand
      lastFourDigits
      expirationMonth
      expirationYear
    }
    items {
      id
      description
      amount
    }
  }
`;
